import { Home, Menu, Refresh } from "@mui/icons-material";
import {
  AppBar,
  Box,
  CircularProgress,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MenuDrawer from "../MenuDrawer";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES, MENU_ITEM } from "../common/constants";
import Notifier from "../common/Notifier";
import { signOutUser } from "../common/auth";
const Header = ({ menuHandler = () => {}, changeTheme = () => {} }) => {
  const { t, i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const destroy = Notifier.subscribe("loading", (flag) => {
      setLoading(flag);
    });
    return () => {
      destroy();
    };
  }, []);

  const isHome = window.location.pathname === APP_ROUTES.home;

  const hideMenu = (item) => {
    menuHandler(item);
    setShowMenu(false);

    switch (item) {
      case MENU_ITEM.updateSchedule:
        navigate(APP_ROUTES.updateSchedule);
        return;
      case MENU_ITEM.changeTheme:
        changeTheme();
        return;
      case MENU_ITEM.logout:
        signOutUser();
        return;
      case MENU_ITEM.language:
        changeLanguage();
        return;
      case MENU_ITEM.contactUs:
        navigate(APP_ROUTES.contactUs);
        return;
      default:
        navigate(APP_ROUTES.home);
        return;
    }
  };

  const changeLanguage = () => {
    const language = i18n.language === "en" ? "ta" : "en";
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  const refresh = () => {
    Notifier.notify("refresh");
  };

  const gotoHome = () => {
    navigate(APP_ROUTES.home);
  };
  return (
    <Box sx={{ flexGrow: 1, justifyContent: "center", alignItems: "center" }}>
      <MenuDrawer
        visible={showMenu}
        onClose={(item) => {
          hideMenu(item);
        }}
      />
      <AppBar position="static">
        <Toolbar sx={{ flexGrow: 1, justifyContent: "space-between" }}>
          <Box sx={{ minWidth: "36px" }}>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setShowMenu(true)}
            >
              <Menu />
            </IconButton>
          </Box>
          <Typography
            variant="h6"
            sx={{ textAlign: "center" }}
            onClick={() => {
              navigate(APP_ROUTES.home);
            }}
          >
            {t("clinic-name")}
          </Typography>

          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={isHome ? refresh : gotoHome}
          >
            {isHome ? (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : (
                  <Refresh />
                )}
              </>
            ) : (
              <Home />
            )}
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
